import React from 'react';

export default function SectionHeaderSkeleton() {
  return (
    <div className="mb-5 mt-1.5 w-1/2 h-9 bg-gray-300 rounded animate-pulse" />
  );
}
